<template>
  <a-spin :spinning="combatLoading" v-if="combatData.length != 1">
    <div class="titleDiv">
      <div></div>
      <p class="title">选择参赛组别</p>
    </div>
    <div class="contentWarp" v-if="combatData.length > 0">
      <div
        :class="combatCheck != null && combatCheck.combatDetailId === combat.combatDetailId ? 'childred check' : 'childred default'"
        v-for="(combat, index) in combatData"
        :key="index"
        @click="combatClick(combat)" >
        {{ combat.groupName }}
      </div>
    </div>
    <a-alert type="warning" v-if="combatData.length === 0" style="width:100%;">
      <div style="margin: 0 auto;" slot="description" v-if="!combatLoading">
        <a-empty :image="simpleImage">
          <span slot="description">暂无项目信息</span>
        </a-empty>
      </div>
    </a-alert>
    <a-alert
      class="ageAlert"
      v-if="combatCheck != null"
      :message="'该组别年龄限制范围：' + combatCheck.minAge + ' ~ ' + combatCheck.maxAge + ' 性别限制：' + (combatCheck.sex === 0 ? '无' : (combatCheck.sex === 2 ? '女' : '男'))"
      banner/>
  </a-spin>
</template>
<script>
import { Empty } from 'ant-design-vue'
export default {
  data () {
    return {
      combatLoading: false,
      combatVisible: true,
      combatData: [],
      combatCheck: null,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
    }
  },
  mounted () {
    this.queryCombatData()
  },
  methods: {
    queryCombatData () {
      this.combatLoading = true
      this.$api.join.findBigballCombatDetail(this.$route.query.matchId).then(res => {
        if (res.status === 0) {
          this.combatData = res.data
          if (this.combatData.length === 1) {
            this.$emit('combatChecked', this.combatData[0])
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('获取比赛项目失败')
      }).finally(_ => {
        this.combatLoading = false
      })
    },
    combatClick (combat) {
      this.combatCheck = combat
      this.$emit('combatChecked', combat)
    }
  }
}
</script>
<style lang="scss" scoped>
  .titleDiv {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    div {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    .title {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
  .contentWarp {
    display: flex;
    flex-wrap: wrap;
    .childred {
      min-width: 100px;
      min-height: 40px;
      margin-right:10px;
      margin-bottom: 10px;
      text-align: center;
      line-height: 40px;
      padding-left:10px;
      padding-right: 10px;
      cursor: pointer;
    }
    .default {
      background-color: #fff;
      color: black;
      border: 1px solid #dbdbdb;
    }
    .check {
      background-color: #b80000;
      color: white;
      border: 1px solid #b80000;
    }
  }
  .ageAlert {
    width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/CombatChoice.vue